import { PurchaseOrderAPIService } from "../purchaseOrderAPIService";
import {
  ReceivingDiscrepancy,
  GetPurchaseOrderReceivingDiscrepancyQueryParams,
  PatchPurchaseOrderReceivingDiscrepancyRequestBody
} from "src/types";

class ReceivingDiscrepancyAPIService extends PurchaseOrderAPIService {
  async getPurchaseOrderReceivingDiscrepancyById(
    purchaseOrderId: string,
    queryParams?: GetPurchaseOrderReceivingDiscrepancyQueryParams
  ): Promise<ReceivingDiscrepancy> {
    const pathParam = encodeURIComponent(purchaseOrderId);
    const path = `/${pathParam}/receiving-discrepancy`;

    return await this.jwtRequest("GET", path, undefined, queryParams);
  }

  async patchPurchaseOrderReceivingDiscrepancyResolution(
    purchaseOrderId: string,
    requestBody: PatchPurchaseOrderReceivingDiscrepancyRequestBody
  ): Promise<ReceivingDiscrepancy> {
    const pathParam = encodeURIComponent(purchaseOrderId);
    const path = `/${pathParam}/receiving-discrepancy/resolution`;

    return await this.jwtRequest("PATCH", path, requestBody);
  }
}

export { ReceivingDiscrepancyAPIService };
